import axios from "axios";

export default class AgencyApi {

  async getSiteData(agencyId) {
    return await axios.get(`/api/siteData/${agencyId}`);
  }

  async getPageContent(page) {
    let siteId = this.getCookie('x-siteId');
    return await axios.get(`/api/page/${siteId}/${page}`);
  }

  async getDestination(destination) {
    let siteId = this.getCookie('x-siteId');
    return await axios.get(`/api/destination/${siteId}/${destination}`);
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

}